import script from "./noticeList.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeList.vue?vue&type=script&setup=true&lang=js"

import "./noticeList.vue?vue&type=style&index=0&id=0706fd57&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0706fd57"]])

export default __exports__